/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1761
 */

"use strict"

var r = require(/* 257 */"../1754/257/index")
var /* [auto-meaningful-name] */require_828_$_828$includes = require(/* 828 */"./828").includes
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("includes", function (e) {
  return require_828_$_828$includes(r$aTypedArray(this), e, arguments.length > 1 ? arguments[1] : undefined)
})
